import React, { useState } from 'react';
import { Box, Button, Text, Input } from '@chakra-ui/react';

const Puzzle = () => {
  const [answer, setAnswer] = useState('');
  const [solved, setSolved] = useState(false);

  const checkAnswer = () => {
    if (answer.toLowerCase() === 'cthulhu fhtagn') {
      setSolved(true);
    } else {
      alert('The ancient ones are not pleased...');
    }
  };

  return (
    <Box p={5} shadow="md" borderWidth="1px">
      <Text mb={4}>Solve the ancient riddle:</Text>
      <Text fontStyle="italic" mb={4}>
        "That is not dead which can eternal lie, And with strange aeons even death may die."
      </Text>
      <Text mb={4}>What is the phrase that awakens the great old one?</Text>
      <Input
        placeholder="Enter the eldritch phrase"
        value={answer}
        onChange={(e) => setAnswer(e.target.value)}
        mb={4}
      />
      <Button colorScheme="teal" onClick={checkAnswer} isDisabled={solved}>
        {solved ? 'Solved' : 'Solve'}
      </Button>
      {solved && <Text mt={4}>You have unlocked the ancient secrets!</Text>}
    </Box>
  );
};

export default Puzzle;
